var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-information"},[(_vm.instance === "chelyabinsk")?_c('chelyabinsk-info'):_c('default-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }